import { GetPaymentsOwedResponseType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

export const usePaymentsOwed = (tripId: string | undefined) => {
    return useQuery<GetPaymentsOwedResponseType>({
        queryKey: queryKeys.paymentsOwed(tripId),
        queryFn: async () => {
            if (!tripId) {
                throw new Error('Trip ID is required')
            }
            const response = await api.get<GetPaymentsOwedResponseType>(
                `/trips/${tripId}/paymentsOwed`,
            )
            return response.data
        },
        enabled: !!tripId,
        retry: 1,
    })
}
